import axios from 'axios';
import {Auth} from "aws-amplify";
import Cookies from 'js-cookie';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_AMI_ENDPOINT, // our API base URL
});

const cenralAPI = axios.create({
    baseURL: process.env.REACT_APP_CENTRAL_ADMIN_API, // our API base URL
});

const cphAPI = axios.create({
    baseURL: process.env.REACT_APP_QUICKDB_URL, // our API base URL
});
export const getToken = async () => {
    try {
        const session = await Auth.currentSession();
        return session.accessToken.jwtToken;
    } catch {
        return null;
    }
};

let getCentralAdminId = async () => {
    const loggedInUserId = Cookies.get('loggedInUserId');
    const user = await Auth.currentUserInfo();
    if (user && user.attributes) {
        return user.attributes['custom:central_user_id'];
    }
    return "";
}

//user.attributes['custom:central_user_id']
//'https://deliveryiotdevapi.rehrig.com
// Request interceptor for adding the bearer token
api.interceptors.request.use(
    async(config) => {
        const token = localStorage.getItem('token'); // Assuming you store the token in localStorage
       // const session = await Auth.currentSession();
        //const loggedInUserIDToken = session.accessToken.jwtToken;
       // if (loggedInUserIDToken) {
            config.headers.Authorization = "Bearer "+await getToken();//`Bearer ${loggedInUserIDToken}`;
            //console.log("config.headers.Authorization....",config.headers.Authorization)
            config.headers['x-api-key'] = 'jPJoEqjzqC9NjMpWroPPH8G0vWQTV4Kcazb5LXMp';
            //config.headers.Authorization = `Bearer ${loggedInUserIDToken}`;
       // }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

cenralAPI.interceptors.request.use(
    async(config) => {
        const token = localStorage.getItem('token'); // Assuming you store the token in localStorage
       // const session = await Auth.currentSession();
        //const loggedInUserIDToken = session.accessToken.jwtToken;
       // if (loggedInUserIDToken) {
            config.headers.Authorization = await getToken();//`Bearer ${loggedInUserIDToken}`;
            //config.headers['x-api-key'] = 'jPJoEqjzqC9NjMpWroPPH8G0vWQTV4Kcazb5LXMp';
            //config.headers.Authorization = `Bearer ${loggedInUserIDToken}`;
       // }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

cphAPI.interceptors.request.use(
    async(config) => {
        // const token = localStorage.getItem('token'); // Assuming you store the token in localStorage
        // const session = await Auth.currentSession();
        // const loggedInUserIDToken = session.accessToken.jwtToken;
        // if (loggedInUserIDToken) {
            config.headers.Authorization = await getToken();//`Bearer ${loggedInUserIDToken}`;
            //config.headers['x-api-key'] = 'jPJoEqjzqC9NjMpWroPPH8G0vWQTV4Kcazb5LXMp';
            //config.headers.Authorization = `Bearer ${loggedInUserIDToken}`;
       // }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// API endpoints
export const getUser = () => {
    return api.get('/user');
};

export const deleteUser = (userId) => {
    return api.delete(`/user/${userId}`);
};

export const getRouteDetails = (routeId) => {
    let routeUrl = `/v2/routes/${routeId}`;
    return api.get(routeUrl);
};
export const getRouteMapHeartbeats = (routeId) => {
    let routeUrl = `/v2/routes/${routeId}/heartbeats`;
    return api.get(routeUrl);
};

export const getRouteMapDeltaHeartbeats = (routeId) => {
    let routeUrl = `/v2/routes/${routeId}/heartbeats?previousTimeStamp=${new Date().toISOString().split('.')[0]+"Z"}`;
    return api.get(routeUrl);
};

export const getLiftCurrentLocation = (routeId) => {
    let routeUrl = `v2/lifts/location/${routeId}`;
    return api.get(routeUrl);
};

export const getAssetSummaryData = (custId,locId) => {
    let routeUrl = `v2/assets/summary?locationId=${locId}&customerId=${custId}`;
    return api.get(routeUrl);
};

export const getAssetAtStore = (custId,locId,pg) => {
    let routeUrl = `v2/assets/stores?locationId=${locId}&customerId=${custId}&locationStatus=store&pageSize=500&pageNumber=${pg}`;
    return api.get(routeUrl);
};
export const getAssetAtLost = (custId,locId,pg) => {
    let routeUrl = `v2/assets?locationId=${locId}&customerId=${custId}&locationStatus=lost&pageSize=500&pageNumber=${pg}`;
    return api.get(routeUrl);
};
export const getAssetAtDC = (custId,locId,pg) => {
    let routeUrl = `v2/assets?locationId=${locId}&customerId=${custId}&locationStatus=dc&pageSize=500&pageNumber=${pg}`;
    return api.get(routeUrl);
};
export const deleteRFIDTags = (rfid, reasonCode, notes, customerId, locationId) => {
    let routeUrl = `v2/assets`;
    return api.delete(routeUrl, {
        data: {
            rfid,
            reasonCode,
            notes: notes || undefined,
            customerId: customerId || undefined,
            locationId: locationId || undefined,
        },
        timeout: 30000
    });
};

export const getReasonCodes = () => {
    let routeUrl = `v2/assets/reason-codes`;
    return api.get(routeUrl, { timeout: 30000 });
};

export const getArchiveRecords = ({ startDate, endDate, reasonCode, userName, customerId, locationId, page = 1, pageSize = 25 }) => {
    let params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (reasonCode) params.append('reasonCode', reasonCode);
    if (userName) params.append('userName', userName);
    if (customerId) params.append('customerId', customerId);
    if (locationId) params.append('locationId', locationId);
    params.append('pageNumber', page);
    params.append('pageSize', pageSize);
    let routeUrl = `v2/assets/archive?${params.toString()}`;
    return api.get(routeUrl, { timeout: 30000 });
};

export const exportArchiveCSV = ({ startDate, endDate, reasonCode, userName, customerId, locationId }) => {
    let params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (reasonCode) params.append('reasonCode', reasonCode);
    if (userName) params.append('userName', userName);
    if (customerId) params.append('customerId', customerId);
    if (locationId) params.append('locationId', locationId);
    params.append('format', 'csv');
    let routeUrl = `v2/assets/archive?${params.toString()}`;
    return api.get(routeUrl, { timeout: 30000 });
};

export const recoverAssets = (rfid) => {
    let routeUrl = `v2/assets/recover`;
    return api.post(routeUrl, { rfid }, { timeout: 30000 });
};

/**
 * Assign a lost pallet (identified by RFID) to a specific route stop.
 *
 * PATCH /v2/assets/{rfid}/assign-stop
 *
 * Request body:
 *   {
 *     "routeStopsId": number,   // DUO_ROUTE_STOPS.Route_Stops_ID
 *     "localRouteId": number,   // DUO_ROUTE_HEADER.LOCAL_ROUTE_ID
 *     "stopNumber":  number     // stop sequence number for display / audit
 *   }
 *
 * Expected response:
 *   200 { success: true }
 *   400 { message: "..." }   validation error
 *   404 { message: "..." }   rfid or stop not found
 */
export const assignPalletToStop = (rfid, routeStopsId, localRouteId, stopNumber) => {
    const routeUrl = `v2/assets/${encodeURIComponent(rfid)}/assign-stop`;
    return api.patch(routeUrl, { routeStopsId, localRouteId, stopNumber }, { timeout: 30000 });
};
export const getUserDetails = async() => {
    /*const loggedInUserId = Cookies.get('loggedInUserId');
    let routeUrl;
    if(loggedInUserId){
        routeUrl = `/Central/user/${loggedInUserId}`;
    }else{
        let userId = await getCentralAdminId();
        routeUrl = `/Central/user/${userId}`;
    }*/
    let userId = await getCentralAdminId();
    let routeUrl = `/Central/user/${userId}`;
    return cenralAPI.get(routeUrl);
};
export const getLostPalletConfig = (custId) => {
    let routeUrl = `v2/assets/getcustomer?customerId=${custId}`;
    return api.get(routeUrl);
};

export const getLostPalletLocConfig = (locId) => {
    let routeUrl = `v2/assets/getlocation?locationId=${locId}`;
    return api.get(routeUrl);
};

export const savePallsetLostCustomerConfig = (custId,req) => {
    let routeUrl = `v2/assets/customer/${custId}`;
    return api.put(routeUrl,req);
};
export const savePallsetLostLocationConfig = (locId,req) => {
    let routeUrl = `v2/assets/location/${locId}`;
    return api.put(routeUrl,req);
};
export const getEmbeddedURL = (appName,dbId,db) => {

    let dbUrl = `qs/v1/embed-url?app_name=${appName}&id=${dbId}&type=${db}`;
    return cphAPI.get(dbUrl);
};

/* ------------------------------------------------------------------ *
 * DIoT Self-Service Portal — Alert configuration (task 19.3)
 *
 * These call the DIoT config-service `/diot/alerts` CRUD endpoints
 * (duo-iot-service-assets `alertConfig` Lambda) through the SAME `api`
 * axios instance the rest of the DIoT pages use — so they inherit the
 * shared base URL (`REACT_APP_API_AMI_ENDPOINT`, the DIoT API gateway)
 * plus the bearer-token + `x-api-key` request interceptor. No new fetch
 * client is introduced.
 *
 * Payload/response shapes mirror the backend contract:
 *   GET    /diot/alerts?locationId=..  -> { alerts: [ {alertId, alertType,
 *            enabled, triggerMode|eventMask|thresholdValue} ] }
 *   POST   /diot/alerts                -> serialized alert
 *   PUT    /diot/alerts/{id}           -> serialized alert
 *   DELETE /diot/alerts/{id}
 * ------------------------------------------------------------------ */

export const getDiotAlerts = (locationId) => {
    return api.get(`v2/diot/alerts?locationId=${encodeURIComponent(locationId)}`);
};

export const createDiotAlert = (payload) => {
    return api.post(`v2/diot/alerts`, payload);
};

export const updateDiotAlert = (alertId, payload) => {
    return api.put(`v2/diot/alerts/${encodeURIComponent(alertId)}`, payload);
};

export const deleteDiotAlert = (alertId, locationId) => {
    return api.delete(`v2/diot/alerts/${encodeURIComponent(alertId)}`, {
        params: locationId != null ? { locationId } : undefined,
    });
};

/* ------------------------------------------------------------------ *
 * DIoT Self-Service Portal — Contacts CRUD (task 19.4)
 *
 * Calls the DIoT config-service `/diot/contacts` endpoints
 * (duo-iot-service-assets `contacts` Lambda) through the SAME shared
 * `api` axios instance (base `REACT_APP_API_AMI_ENDPOINT` + bearer /
 * x-api-key interceptor). No new client is introduced.
 *
 * Backend contract:
 *   GET    /diot/contacts?locationId=..  -> { contacts: [ {contactId,
 *            name, email, phone} ] }  (email/phone MASKED in list responses)
 *   POST   /diot/contacts                { locationId, customerId?, name,
 *            email?, phone? }  -> serialized contact
 *   PUT    /diot/contacts/{id}           { locationId, name?, email?, phone? }
 *   DELETE /diot/contacts/{id}?locationId=..  -> { message, contactId }
 * Validation errors surfaced: 400 CONTACT_CHANNEL_REQUIRED, 400 INVALID_PHONE.
 * ------------------------------------------------------------------ */

export const getDiotContacts = (locationId) => {
    return api.get(`v2/diot/contacts?locationId=${encodeURIComponent(locationId)}`);
};

export const createDiotContact = (payload) => {
    return api.post(`v2/diot/contacts`, payload);
};

export const updateDiotContact = (contactId, payload) => {
    return api.put(`v2/diot/contacts/${encodeURIComponent(contactId)}`, payload);
};

export const deleteDiotContact = (contactId, locationId) => {
    return api.delete(`v2/diot/contacts/${encodeURIComponent(contactId)}`, {
        params: locationId != null ? { locationId } : undefined,
    });
};

/* ------------------------------------------------------------------ *
 * DIoT Self-Service Portal — Subscriptions matrix (task 19.4)
 *
 * Calls the DIoT config-service `/diot/subscriptions` endpoints
 * (duo-iot-service-assets `subscriptions` Lambda) through the SAME shared
 * `api` axios instance.
 *
 * Backend contract:
 *   GET /diot/subscriptions?locationId=..  -> { matrix: [ {contactId,
 *         alertId, smsEnabled, emailEnabled} ] }
 *   PUT /diot/subscriptions   { locationId, customerId?, matrix: [ {contactId,
 *         alertId, smsEnabled, emailEnabled} ] }  -> { matrix: [...] }
 *     The PUT ATOMICALLY replaces the ENTIRE DC subscription set in one call.
 * Validation error surfaced: 409 DUPLICATE_SUBSCRIPTION.
 * ------------------------------------------------------------------ */

export const getDiotSubscriptions = (locationId) => {
    return api.get(`v2/diot/subscriptions?locationId=${encodeURIComponent(locationId)}`);
};

export const putDiotSubscriptions = (payload) => {
    return api.put(`v2/diot/subscriptions`, payload);
};

/* ------------------------------------------------------------------ *
 * DIoT Self-Service Portal — Lift mapping + display preference (task 19.5)
 *
 * Calls the DIoT config-service `/diot/lift-mapping*` endpoints
 * (duo-iot-service-assets `liftMapping` Lambda) through the SAME shared
 * `api` axios instance (base `REACT_APP_API_AMI_ENDPOINT` + bearer /
 * x-api-key interceptor). No new client is introduced.
 *
 * Backend contract (confirmed from src/diotLiftMapping/index.py):
 *   GET  /diot/lift-mapping?locationId=..
 *        -> { lifts: [ { liftId, customerLiftAlias, liftName } ] }
 *          (liftId read-only, customerLiftAlias editable)
 *   PUT  /diot/lift-mapping   { locationId, liftId, customerLiftAlias? }
 *        -> { liftId, customerLiftAlias, liftName }
 *          writes ONLY the alias; a null/blank customerLiftAlias CLEARS it.
 *   POST /diot/lift-mapping/import  { locationId, csv }  (or { rows: [...] })
 *        -> { updatedCount, skippedCount,
 *             updated: [ { liftId, customerLiftAlias } ],
 *             skipped: [ { liftId, reason } ] }
 *          reason is LIFT_NOT_FOUND (unknown liftId for the DC),
 *          MISSING_LIFT_ID or INVALID_LIFT_ID for unparseable rows.
 *   GET  /diot/lift-mapping/display-preference?locationId=..
 *        -> { liftDisplayPreference: "CUSTOMER" | "REHRIG" }  (defaults CUSTOMER)
 *   PUT  /diot/lift-mapping/display-preference  { locationId, liftDisplayPreference }
 *        -> { liftDisplayPreference }
 * Validation error surfaced: 400 INVALID_DISPLAY_PREFERENCE.
 * ------------------------------------------------------------------ */

export const getDiotLiftMapping = (locationId) => {
    return api.get(`v2/diot/lift-mapping?locationId=${encodeURIComponent(locationId)}`);
};

export const updateDiotLiftMapping = (payload) => {
    return api.put(`v2/diot/lift-mapping`, payload);
};

export const importDiotLiftMapping = (payload) => {
    return api.post(`v2/diot/lift-mapping/import`, payload);
};

/* EDN-style bulk-import wizard (parse -> preview -> apply). All three POST the
 * SAME `/diot/lift-mapping/import` route, discriminated by the `action` field,
 * so no new API Gateway route is needed. Payload: { locationId, csv,
 * columnMapping? }. Responses are wrapped in the shared `{ Response: ... }`
 * envelope by the backend. */

export const parseDiotLiftImport = (payload) => {
    return api.post(`v2/diot/lift-mapping/import`, { ...payload, action: "parse" });
};

export const previewDiotLiftImport = (payload) => {
    return api.post(`v2/diot/lift-mapping/import`, { ...payload, action: "preview" });
};

export const applyDiotLiftImport = (payload) => {
    return api.post(`v2/diot/lift-mapping/import`, { ...payload, action: "apply" });
};

export const getDiotLiftDisplayPreference = (locationId) => {
    return api.get(
        `v2/diot/lift-mapping/display-preference?locationId=${encodeURIComponent(locationId)}`
    );
};

export const putDiotLiftDisplayPreference = (payload) => {
    return api.put(`v2/diot/lift-mapping/display-preference`, payload);
};

/* ------------------------------------------------------------------ *
 * DIoT Self-Service Portal — Route settings & Asset settings (task 19.6)
 *
 * Calls the DIoT config-service `/diot/route-settings` and
 * `/diot/asset-settings` endpoints (duo-iot-service-assets `routeSettings`
 * and `assetSettings` Lambdas) through the SAME shared `api` axios instance
 * (base `REACT_APP_API_AMI_ENDPOINT` + bearer / x-api-key interceptor). No new
 * client is introduced. Both are one-row-per-DC UPSERTs.
 *
 * Backend contract (confirmed from src/diotRouteSettings/index.py):
 *   GET /diot/route-settings?locationId=..
 *       -> { routeSettings: { locationId, amOffsetMin, pmOffsetMin } }
 *          (offsets null when no row persisted yet)
 *   PUT /diot/route-settings  { locationId, customerId?, amOffsetMin, pmOffsetMin }
 *       -> { locationId, amOffsetMin, pmOffsetMin }  (UPSERT — one row per DC)
 *          amOffsetMin shifts route START earlier; pmOffsetMin shifts route END
 *          later (minutes; null/absent = 0).
 *   Validation errors surfaced: 400 INVALID_AM_OFFSET_MIN, INVALID_PM_OFFSET_MIN.
 *
 * Backend contract (confirmed from src/diotAssetSettings/index.py):
 *   GET /diot/asset-settings?locationId=..
 *       -> { settings: { locationId, minLostPallets } }  (null when unset)
 *   PUT /diot/asset-settings  { locationId, customerId?, minLostPallets }
 *       -> { settings: { locationId, minLostPallets, settingsId } }
 *   Validation error surfaced: 400 INVALID_MIN_LOST_PALLETS.
 * ------------------------------------------------------------------ */

export const getDiotRouteSettings = (locationId) => {
    return api.get(`v2/diot/route-settings?locationId=${encodeURIComponent(locationId)}`);
};

export const putDiotRouteSettings = (payload) => {
    return api.put(`v2/diot/route-settings`, payload);
};

export const getDiotAssetSettings = (locationId) => {
    return api.get(`v2/diot/asset-settings?locationId=${encodeURIComponent(locationId)}`);
};

export const putDiotAssetSettings = (payload) => {
    return api.put(`v2/diot/asset-settings`, payload);
};

/* ------------------------------------------------------------------ *
 * DIoT Self-Service Portal — Alert history (cursor) + Audit log (offset)
 * (task 19.6)
 *
 * Calls the DIoT config-service `/diot/history` and `/diot/audit` read
 * endpoints (duo-iot-service-assets `alertHistory` and `auditLog` Lambdas)
 * through the SAME shared `api` axios instance. Both are read-only views.
 *
 * Backend contract (confirmed from src/diotHistory/index.py):
 *   GET /diot/history?locationId=..&limit=..&cursor=..
 *       -> { items: [ { createdAt, alertUid, alertType, customerId,
 *            locationId, status, deepLink } ], nextCursor }
 *          CURSOR pagination: pass the previous `nextCursor` to fetch the next
 *          page; `nextCursor` is null on the terminal page. Items are
 *          created-DESC (newest first). `limit` defaults to 25 (max 100).
 *   GET /diot/history?locationId=..&format=csv
 *       -> the CSV export as a JSON-encoded string in the `Response` envelope
 *          (walks every page for the DC). Same download idiom as
 *          `exportArchiveCSV`.
 *
 * Backend contract (confirmed from src/diotAudit/index.py):
 *   GET /diot/audit?locationId=..&offset=..&limit=..
 *       -> { items: [ { auditId, actor, entity, entityId, action, beforeJson,
 *            afterJson, createdAt } ], total }
 *          OFFSET/FETCH pagination, created-DESC. `offset` defaults to 0,
 *          `limit` defaults to 50 (max 200). `total` is the full row count for
 *          the DC so the client can page.
 * ------------------------------------------------------------------ */

export const getDiotHistory = (locationId, { limit, cursor } = {}) => {
    const params = new URLSearchParams();
    params.append('locationId', locationId);
    if (limit != null) params.append('limit', limit);
    if (cursor) params.append('cursor', cursor);
    return api.get(`v2/diot/history?${params.toString()}`);
};

export const exportDiotHistoryCSV = (locationId) => {
    const params = new URLSearchParams();
    params.append('locationId', locationId);
    params.append('format', 'csv');
    return api.get(`v2/diot/history?${params.toString()}`, { timeout: 30000 });
};

export const getDiotAudit = (locationId, { offset, limit } = {}) => {
    const params = new URLSearchParams();
    params.append('locationId', locationId);
    if (offset != null) params.append('offset', offset);
    if (limit != null) params.append('limit', limit);
    return api.get(`v2/diot/audit?${params.toString()}`);
};

// Export the api instance
export default api;
